export default "__VITE_ASSET__Bb0Q4hxo__"